<template>
  <v-app>
    <v-main>
      <!-- class="py-12" -->
      <v-container
        :class="{
          'py-12': $vuetify.breakpoint.mdAndUp,
          'pa-4': !$vuetify.breakpoint.mdAndUp
        }"
        style="height: 100%"
      >
        <router-link :to="{ name: $constants.ROUTE_NAME.HOME }">
          <img
            :class="{
              'mb-10': $vuetify.breakpoint.mdAndUp,
              'mb-4': !$vuetify.breakpoint.mdAndUp
            }"
            src="@/assets/oly-logo.png"
          />
        </router-link>
        <router-view style="height: 100%"></router-view>
      </v-container>
    </v-main>
    <Footer />
  </v-app>
</template>

<script>
import Footer from '@/components/Footer.vue'

export default {
  name: 'PlainLayout',

  components: {
    Footer
  }
}
</script>
